import { Navigate } from 'react-router-dom';

/**
 * The flat rack-grid model (rows×cols slots) is superseded by the
 * storage-location hierarchy ("lager/hylleplassering" — Rom → Skap/
 * Kjøleskap → Hylle) driving the Kjeller page's sidebar + table. There was
 * no real usage of `/racks` to migrate (0 real-world rack/bottle
 * assignments), so this route now just redirects instead of shipping two
 * competing location UIs. The backend `racks` table/routes are left
 * untouched for back-compat — see store/cellar-repository.ts.
 */
export function RacksPage() {
  return <Navigate to="/cellar" replace />;
}
